import React, { memo, useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { TemplateTypeEnum } from '@bringg/types';

import { DELIVERY_REPORT_TYPE_LABEL_KEYS } from '../../consts';

import styles from './styles.module.scss';

interface Props {
	type: TemplateTypeEnum;
}

function TemplateTypeCell({ type }: Props) {
	const { t } = useTranslation();

	const typeNames = useMemo(
		() => ({
			[TemplateTypeEnum.customer_notification_email]: t('EMAIL_TEMPLATES.EMAIL_TYPE'),
			[TemplateTypeEnum.print_order]: t('TEMPLATES.PRINT_ORDER_TYPE'),
			[TemplateTypeEnum.package_label]: t('EMAIL_TEMPLATES.LABEL_TYPE'),
			[TemplateTypeEnum.customer_facing_delivery_report]: t(
				DELIVERY_REPORT_TYPE_LABEL_KEYS[TemplateTypeEnum.customer_facing_delivery_report]
			),
			[TemplateTypeEnum.internal_delivery_report]: t(
				DELIVERY_REPORT_TYPE_LABEL_KEYS[TemplateTypeEnum.internal_delivery_report]
			),
			[TemplateTypeEnum.service_quality_report]: t(
				DELIVERY_REPORT_TYPE_LABEL_KEYS[TemplateTypeEnum.service_quality_report]
			)
		}),
		[t]
	);

	return (
		<span>
			<span
				className={classnames(styles.typeIcon, {
					[styles.emailType]: type === TemplateTypeEnum.customer_notification_email
				})}
			></span>
			{typeNames[type]}
		</span>
	);
}

export default memo(TemplateTypeCell);
